import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-550e6729"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "column-tabs"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tab-chip__dot"
}, null, -1));
const _hoisted_4 = {
  class: "tab-chip__label"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增栏目", -1));
import { nextTick, onMounted, ref, watch } from 'vue';
import { Modal } from 'ant-design-vue';
import { CloseOutlined, LeftOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnTabs',
  props: {
    columns: null,
    activeId: null,
    onAddColumn: null,
    onDeleteColumn: null
  },
  emits: ["change"],
  setup(__props) {
    const props = __props;
    /**
     * 栏目 Tab 组件
     * - 展示横向 Tab + 左右滚动按钮（不可滚动时禁用）
     * - hover Tab 显示删除小 ×（删除有二次确认）
     * - 末尾「+ 新增栏目」按钮（虚线胶囊样式）
     * - 新增弹窗：内联红字校验 + 防连点 + 回车提交
     *
     * 数据交互全部由父层处理（emit 出事件）：
     * - change  切换栏目
     * - add     新增栏目（返回 boolean 控制弹窗是否关闭）
     * - delete  删除栏目（返回 boolean，Modal.confirm 内部用于 loading 控制）
     */
    // 滚动容器引用 + 左右可滚状态（用于按钮 disabled 控制）
    const scrollEl = ref(null);
    const canScrollLeft = ref(false);
    const canScrollRight = ref(false);
    // 新增栏目弹窗状态
    const addModalOpen = ref(false);
    const newColumnName = ref('');
    const adding = ref(false); // 提交中 → 阻止重复点击 / 回车
    const nameError = ref(''); // 表单内联红字提示
    /**
     * 计算左右滚动按钮的禁用状态
     * 用 SCROLL_THRESHOLD 像素阈值避免小数像素误差导致的边界抖动
     */
    const SCROLL_THRESHOLD = 4;
    const updateScrollState = () => {
      const el = scrollEl.value;
      if (!el) return;
      canScrollLeft.value = el.scrollLeft > SCROLL_THRESHOLD;
      canScrollRight.value = el.scrollLeft + el.clientWidth < el.scrollWidth - SCROLL_THRESHOLD;
    };
    /** 横向滚动（左右箭头点击触发） */
    const scrollBy = delta => {
      var _scrollEl$value;
      (_scrollEl$value = scrollEl.value) === null || _scrollEl$value === void 0 || _scrollEl$value.scrollBy({
        left: delta,
        behavior: 'smooth'
      });
    };
    /** 打开新增栏目弹窗，重置表单与错误态 */
    const openAddModal = () => {
      newColumnName.value = '';
      nameError.value = '';
      addModalOpen.value = true;
    };
    const handleCancelAdd = () => {
      addModalOpen.value = false;
      newColumnName.value = '';
      nameError.value = '';
    };
    /**
     * 新增栏目提交
     * 校验顺序：
     * 1) 防重复提交（adding guard，防回车连按）
     * 2) 内联非空校验（红字显示在输入框下方）
     * 3) emit 'add' 给父层调接口；返回 true 才关闭弹窗
     */
    const handleConfirmAdd = async () => {
      if (adding.value) return;
      const name = newColumnName.value.trim();
      if (!name) {
        nameError.value = '请填写栏目名称';
        return;
      }
      nameError.value = '';
      adding.value = true;
      try {
        const ok = await props.onAddColumn(name);
        if (ok) {
          addModalOpen.value = false;
          newColumnName.value = '';
        }
      } finally {
        adding.value = false;
      }
    };
    /**
     * 删除栏目
     * 用 Modal.confirm 二次确认；onOk 返回 Promise 让 ant-design-vue
     * 自动给确定按钮加 loading + 禁用，防止连点
     */
    const handleDeleteClick = col => {
      Modal.confirm({
        title: '确认删除栏目',
        content: `确定要删除栏目「${col.columnName || '未命名栏目'}」吗？此操作不可恢复。`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        centered: true,
        onOk: () => props.onDeleteColumn(col.id)
      });
    };
    onMounted(() => {
      // 首次渲染后计算滚动按钮状态
      nextTick(updateScrollState);
    });
    // 栏目列表变化时重新计算（新增/删除/重命名导致 tab 宽度变化均需更新）
    watch(() => props.columns, () => nextTick(updateScrollState), {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        class: _normalizeClass(["scroll-btn scroll-btn--left", {
          disabled: !canScrollLeft.value
        }]),
        onClick: _cache[0] || (_cache[0] = $event => scrollBy(-200))
      }, [_createVNode(_unref(LeftOutlined))], 2), _createElementVNode("div", {
        ref_key: "scrollEl",
        ref: scrollEl,
        class: "tabs-scroll",
        onScroll: updateScrollState
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, col => {
        return _openBlock(), _createElementBlock("div", {
          key: col.id,
          class: _normalizeClass(["tab-chip", {
            active: col.id === __props.activeId
          }]),
          onClick: $event => _ctx.$emit('change', col.id)
        }, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(col.columnName || '未命名栏目'), 1), _createElementVNode("span", {
          class: "tab-chip__delete",
          title: "删除栏目",
          onClick: _withModifiers($event => handleDeleteClick(col), ["stop"])
        }, [_createVNode(_unref(CloseOutlined))], 8, _hoisted_5)], 10, _hoisted_2);
      }), 128)), _createElementVNode("button", {
        class: "tab-add",
        onClick: openAddModal
      }, [_createVNode(_unref(PlusOutlined)), _hoisted_6])], 544), _createElementVNode("button", {
        class: _normalizeClass(["scroll-btn scroll-btn--right", {
          disabled: !canScrollRight.value
        }]),
        onClick: _cache[1] || (_cache[1] = $event => scrollBy(200))
      }, [_createVNode(_unref(RightOutlined))], 2), _createVNode(_component_a_modal, {
        open: addModalOpen.value,
        "onUpdate:open": _cache[4] || (_cache[4] = $event => addModalOpen.value = $event),
        title: "新增栏目",
        "confirm-loading": adding.value,
        "mask-closable": false,
        "ok-text": "确定",
        "cancel-text": "取消",
        onOk: handleConfirmAdd,
        onCancel: handleCancelAdd
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          layout: "vertical"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "栏目名称",
            required: "",
            "validate-status": nameError.value ? 'error' : '',
            help: nameError.value
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: newColumnName.value,
              "onUpdate:value": [_cache[2] || (_cache[2] = $event => newColumnName.value = $event), _cache[3] || (_cache[3] = $event => nameError.value = '')],
              placeholder: "请输入栏目名称",
              maxlength: 30,
              "show-count": "",
              "allow-clear": "",
              onPressEnter: handleConfirmAdd
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["validate-status", "help"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "confirm-loading"])]);
    };
  }
});